import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalService } from 'ng-zorro-antd/modal';
import { HttpRequestService, LocalStorageService } from 'src/app/core/services';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { ActivatedRoute, Router } from '@angular/router';
import { toNumber } from 'ng-zorro-antd/core/util';
import { environment } from 'src/environments/environment';
import { RejectionReasonComponent } from 'src/app/shared/components/rejection-reason/rejection-reason.component';

@Component({
  selector: 'app-announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.scss'],
})
export class AnnouncementComponent implements OnInit {
  allApprovedAnnouncements: any[] = [];
  allAnnouncements: any[] = [];
  totalApprovedDataCount = 0;
  totalDataCount = 0;
  loading = false;
  mediaBaseUrl = environment.mediaBaseUrl;
  index = 0;
  userRole = '';

  pageSize = 10;
  pageIndex = 1;

  constructor(
    private httpRequestService: HttpRequestService,
    private notificationService: NzNotificationService,
    private modalService: NzModalService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private localStorageService: LocalStorageService,
  ) {
    this.userRole = this.localStorageService.getItem('user').role;
    const snapIndex = toNumber(
      this.activatedRoute.snapshot.queryParams['index'],
    );
    if (snapIndex) {
      this.index = snapIndex;
    }
  }

  ngOnInit(): void {
    this.getAnnouncements(this.index);
  }

  // ─── Tab / Index ─────────────────────────────────────────────────
  changeIndex(index: number): void {
    this.index = index;
    this.router.navigate([], { queryParams: { index } });
    this.pageIndex = 1;
    this.allApprovedAnnouncements = [];
    this.allAnnouncements = [];
    this.getAnnouncements(this.index);
  }

  // ─── Fetch ───────────────────────────────────────────────────────
  getAnnouncements(index: number = this.index): void {
    this.loading = true;
    const params: any = {
      skip: (this.pageIndex - 1) * this.pageSize,
      limit: this.pageSize,
    };

    /* Approval status filter by tab + role */
    if (index === 0) {
      params.approveStatus = 'approved';
    } else if (index === 1 && this.userRole === 'admin') {
      params.approveStatus = 'pending';
    } else if (index === 1 && this.userRole === 'subAdmin') {
      params.approveStatus = ['pending', 'rejected'];
    }

    this.httpRequestService.request('get', 'announcements', params).subscribe(
      (result: any) => {
        this.loading = false;
        if (index === 0) {
          this.allApprovedAnnouncements = result.data || [];
          this.totalApprovedDataCount = result.totalCount || 0;
        } else {
          this.allAnnouncements = result.data || [];
          this.totalDataCount = result.totalCount || 0;
        }
      },
      () => {
        this.loading = false;
      },
    );
  }

  // ─── Pagination ──────────────────────────────────────────────────
  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageSize, pageIndex } = params;
    this.pageSize = pageSize;
    this.pageIndex = pageIndex;
    this.getAnnouncements(this.index);
  }

  // ─── Status / Approve / Reject ──────────────────────────────────
  updateStatus(id: string, status: string): void {
    const newStatus = status === 'active' ? 'inactive' : 'active';
    this.httpRequestService
      .request('put', `announcements/${id}`, { status: newStatus })
      .subscribe(() => {
        this.notificationService.success('', 'Status Updated Successfully');
        this.getAnnouncements(this.index);
      });
  }

  updateApproveStatus(id: string, approveStatus: string): void {
    this.httpRequestService
      .request('put', `announcements/approved-rejected/${id}`, {
        approveStatus,
      })
      .subscribe(() => {
        this.notificationService.success('', 'Status Updated Successfully');
        this.getAnnouncements(this.index);
      });
  }

  openRejectionReason(id: string): void {
    const modal = this.modalService.create({
      nzTitle: 'Add A Reason',
      nzContent: RejectionReasonComponent,
      nzWidth: '800px',
      nzFooter: null,
      nzComponentParams: {
        updateId: id,
        component: 'announcements',
      },
      nzCancelText: null,
      nzOkText: null,
    });
    modal.afterClose.subscribe(() => this.getAnnouncements(this.index));
  }

  // ─── Delete ──────────────────────────────────────────────────────
  confirmDelete(id: string): void {
    this.modalService.confirm({
      nzTitle: 'Delete Announcement',
      nzContent:
        'Are you sure you want to delete this announcement? This action cannot be undone.',
      nzOkText: 'Delete',
      nzOkDanger: true,
      nzOnOk: () => this.deleteAnnouncement(id),
      nzCancelText: 'Cancel',
    });
  }

  deleteAnnouncement(id: string): void {
    this.httpRequestService
      .request('delete', `announcements/${id}`)
      .subscribe(() => {
        this.notificationService.success(
          '',
          'Announcement Deleted Successfully',
        );
        this.getAnnouncements(this.index);
      });
  }

  // ─── Helpers ─────────────────────────────────────────────────────
  isExpired(item: any): boolean {
    return !!item.endDate && new Date(item.endDate).getTime() < Date.now();
  }

  getModuleLabel(module: string): string {
    const map: any = {
      plan: 'Plan',
      testSery: 'Test Series',
      jobAlert: 'Job Alert',
      currentAffairs: 'Current Affairs',
      resource: 'Resource',
      editorials: 'Editorial Corner',
    };
    return map[module] || module;
  }
}
